export default "__VITE_ASSET__BqkayItr__"